import { render, staticRenderFns } from "./attach1.vue?vue&type=template&id=353e063b&scoped=true&"
import script from "./attach1.vue?vue&type=script&lang=js&"
export * from "./attach1.vue?vue&type=script&lang=js&"
import style0 from "./attach1.vue?vue&type=style&index=0&id=353e063b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353e063b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {
  VContainer,
  VLayout,
})
